var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhitepage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.8453 22C44.5598 23.2376 44.5598 24.7624 43.8453 26L35.6547 40.1865C34.9402 41.4241 33.6197 42.1865 32.1906 42.1865L15.8094 42.1865C14.3803 42.1865 13.0598 41.4241 12.3453 40.1865L4.1547 26C3.44017 24.7624 3.44017 23.2376 4.1547 22L12.3453 7.81347C13.0598 6.57586 14.3803 5.81347 15.8094 5.81347L32.1906 5.81347C33.6197 5.81347 34.9402 6.57586 35.6547 7.81347L43.8453 22Z",
    fill: "#7637FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 15H18.75C18.2859 15 17.8408 15.1896 17.5126 15.5272C17.1844 15.8648 17 16.3226 17 16.8V31.2C17 31.6774 17.1844 32.1352 17.5126 32.4728C17.8408 32.8104 18.2859 33 18.75 33H29.25C29.7141 33 30.1592 32.8104 30.4874 32.4728C30.8156 32.1352 31 31.6774 31 31.2V20L26 15Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 15V20H31",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 25H20",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28 28H20",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22 21H21H20",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitepage);
export default __webpack_public_path__ + "static/media/whitepage.91dfc54f0f351ef35819c7f14faf763b.svg";
export { ForwardRef as ReactComponent };